import type { Middleware } from "@reduxjs/toolkit";
import { isRejectedWithValue } from "@reduxjs/toolkit";

interface ErrorPayload {
  status?: number;
  data?: unknown;
}

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as ErrorPayload;
    if (payload?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/auth";
    }
  }
  return next(action);
};
